<template>
  <div class="col-md-12 client_groups">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <tree-select
              :options="client_list"
              :multiple="false"
              v-model="filter.client_id"
              :placeholder="translate('client.one')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <fg-input
              v-model="filter.q"
              type="text"
              :placeholder="translate('search')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select"></div>
        <div class="form_select"></div>
        <div class="form_select"></div>
        <div class="form_select">
          <button type="button" class="btn btn-success btn-fill" disabled>
            <span class="mdi mdi-plus-circle-outline" />
            {{ translate('client_groups.to_add') }}
          </button>
        </div>
      </div>
    </div>

    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th v-for="column in columns" :key="column" scope="col" class="text-left">
              {{ translate('client_groups.' + column) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in group_list" :key="group.id">
            <td class="text-left" :data-label="translate('client_groups.name')">{{ group.name }}</td>
            <td class="text-left" :data-label="translate('client_groups.description')">{{ group.description }}</td>
            <td class="text-left" :data-label="translate('client_groups.clients')">
              <div v-for="client in group.clients" :key="client.id">{{ client.name }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientGroups',
  data () {
    return {
      group_list: [],
      columns: ['name', 'description', 'clients'],
      filter:{
        client_id: null,
        q: ""
      },
      timer: null,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    sended_filter() {
      let filter = {};
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
          filter[key] = this.filter[key]
        }
      })
      return filter;
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'client_list_section' && this.$route.params.client_list_section === 'groups') {
          let string = '?'

          for (let key in this.filter) {
            if (this.filter[key]) {
              string += '&' + key + '=' + encodeURIComponent(this.filter[key])
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
  },
  activated () {
    this.check_query()
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_client_groups, 500)
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_id':
              this.filter.client_id = this.$route.query[key]
              break;
            case 'q':
              this.filter.q = this.$route.query[key]
              break;
          }
        }
      }
      this.load_client_groups()
    },
    load_client_groups(){
      this.$http.v1.getClientGroupList(this.sended_filter, (response) => {
        if (response.data){
          this.group_list = response.data.items
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>

.client_groups{
  height: 100%;
  display: flex;
  flex-direction: column;

  .main_filters{
    top: 20px;
  }

  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
      .btn{
        width: 100%;
      }
    }
  }

  .response_table{
    flex: 10;
    padding: 10px 0 0;
    table{
      th, td {
        font-size: 12px;
      }
    }
  }
}
</style>
